export enum TracklistActionType {
  PLAY = 'play',
  PAUSE = 'pause',
  GO_TO_TRACK = 'go_to_track',
  SHOW_ALL_TRACKS_NOTES = 'show_all_tracks_notes',
  SHOW_NOTES = 'show_notes',
  LINK_TO_SPOTIFY = 'link_to_spotify',
}

export type TracklistAction =
  | { type: TracklistActionType.PLAY }
  | { type: TracklistActionType.PAUSE }
  | { type: TracklistActionType.GO_TO_TRACK; index: number }
  | { type: TracklistActionType.SHOW_ALL_TRACKS_NOTES }
  | { type: TracklistActionType.SHOW_NOTES; trackId: string }
  | { type: TracklistActionType.LINK_TO_SPOTIFY; trackId: string };
